import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SpacingStyles from '../../../../styles/helpers/spacing';
import TypographyStyles from '../../../../styles/typography';
import combineStyles from '../../../../helpers/combineStyles';
import classnames from 'classnames';

import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdfOutlined';

import ItemStyles from './__styles__/item.styles';
import LoadingButton from '../../../shared/Buttons/LoadingButton';

export class Item extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    url: PropTypes.string,
    fetchDocument: PropTypes.func
  };

  state = {
    optionsMenu: null
  };

  _handleOpenOptionsMenu = event => {
    this.setState({ optionsMenu: event.currentTarget });
  };

  _handleCloseOptionsMenu = () => {
    this.setState({ optionsMenu: null });
  };

  _handleClick = async () => {
    const { fetchDocument, url, download } = this.props;
    if (!url) {
      const newUrl = await fetchDocument();
      window.open(newUrl, '_blank');
    }
    if (url) {
      window.open(url, '_blank');
    } else if (download) {
      event.preventDefault();
      window.open(download, '_blank');
    }
  };

  render() {
    const { classes, name, loading } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.detail}>
          <LoadingButton
            variant="text"
            size="small"
            onClick={this._handleClick}
            loading={loading}
            className={classnames(classes.subtitle3, classes.name)}
            style={{
              padding: 0,
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <PictureAsPdfIcon className={classes.fileTypeIcon} />
            <p
              className={classnames(classes.subtitle3, classes.name)}
              style={{ textAlign: 'left' }}
            >
              {name}
            </p>
          </LoadingButton>
        </div>
      </div>
    );
  }
}

export default withStyles(
  combineStyles(ItemStyles, TypographyStyles, SpacingStyles)
)(Item);
